import { makeStyles, Icon, IconButton, Theme, Button } from "@material-ui/core";
import React from "react";
import { NavigationProps } from "../../Types/Types";

export interface NavigationDesktopProps extends NavigationProps {}

const useStyles = makeStyles(
  (theme: Theme) => ({
    navigation: {
      background: theme.palette.grey[200],
    },

    navigationButton: {
      padding: `${theme.spacing(2)}px ${theme.spacing(4)}px`,
    },

    navigationButtonLabel: {
      // TODO: Apply custom font in the future
      textTransform: "initial",
      fontWeight: 600,
    },

    actions: {
      width: "20vw",
      display: "flex",
      justifyContent: "flex-end",
    },
  }),
  { name: "NavigationDesktop" }
);

const NavigationDesktop = ({ items }: NavigationDesktopProps) => {
  const classes = useStyles({});
  const actions = items.filter((item) => item.type === "action" && item.isVisible);

  return (
    <>
      <div className={classes.navigation}>
        {items
          .filter((item) => item.type === "option" && item.isVisible)
          .map((item) => (
            <Button
              key={item.icon}
              classes={{
                root: classes.navigationButton,
                label: classes.navigationButtonLabel,
              }}
              onClick={item.onClick}
              startIcon={<Icon>{item.icon}</Icon>}
            >
              {item.label}
            </Button>
          ))}
      </div>
      {actions.length > 0 && <div className={classes.actions}>
        {actions
          .map((item) => (
            <IconButton
              key={item.label}
              className={classes.iconButton}
              onClick={item.onClick}
            >
              <Icon>{item.icon}</Icon>
            </IconButton>
          ))}
      </div>}
    </>
  );
};

export default NavigationDesktop;
